import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import PrivateRoute from "./auth/PrivateRoute";
import FamiliesList from "./pages/Family/Family";
import Login from "./pages/Login/Login";
import FamilyDetails from "./pages/Family/FamilyDetails";
import { Layout } from "antd";
import Navbar from "./components/Navbar/Navbar";
import { apiInit } from "./services/main.api.service";

function AppContent() {
  apiInit();
  const location = useLocation();

  // Hide navbar on /login
  const hideNavbar = location.pathname === "/login";

  return (
    <Layout className="min-h-screen">
      {!hideNavbar && <Navbar />}
      <Layout.Content className="bg-gray-50">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <FamiliesList />
              </PrivateRoute>
            }
          />
          <Route path="/families/:id/father" element={<FamilyDetails />} />
          <Route path="/families/:id/mother" element={<FamilyDetails />} />

          {/* If you want FamilyForm routes again */}
          {/* <Route
            path="/families/new"
            element={
              <PrivateRoute>
                <FamilyForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/families/:id"
            element={
              <PrivateRoute>
                <FamilyForm />
              </PrivateRoute>
            }
          /> */}
        </Routes>
      </Layout.Content>
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
